"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _default = _react.default.createClass({
  displayName: "ReviewListZeroState",
  propTypes: {
    isAbleToReview: _react.PropTypes.bool.isRequired,
    triggerReviewModal: _react.PropTypes.func.isRequired
  },
  renderFooter: function renderFooter(triggerReviewModal) {
    return _react.default.createElement(_UIButton.default, {
      className: "m-top-2",
      onClick: triggerReviewModal,
      use: "primary"
    }, _I18n.default.text('goodDetails.reviewList.reviewThisProduct'));
  },
  render: function render() {
    var _this$props = this.props,
        isAbleToReview = _this$props.isAbleToReview,
        triggerReviewModal = _this$props.triggerReviewModal;
    return _react.default.createElement(_UISection.default, {
      className: "text-center",
      use: "island"
    }, _react.default.createElement("p", {
      className: "is--heading-5 m-bottom-2"
    }, _I18n.default.text('goodDetails.reviewList.zeroState.header')), _react.default.createElement("p", null, _I18n.default.text('goodDetails.reviewList.zeroState.description')), isAbleToReview ? this.renderFooter(triggerReviewModal) : null);
  }
});

exports.default = _default;
module.exports = exports.default;